import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import Viewport from '@vaersaagod/tools/Viewport';
import agent from '@vaersaagod/tools/request';
import debounce from 'lodash.debounce';
import * as Events from '../lib/events';

export default (el, props) => {
    const dom = $(el);
    const body = $('body');
    const close = dom.find('[data-close]');
    const field = dom.find('[data-search-field]');
    const feedback = dom.find('[data-feedback]');
    const results = dom.find('[data-results]');
    const heading = dom.find('[data-heading]');
    let request = null;
    let active = false;
    let lastQuery = '';
    let trigger = false;

    const keyHandler = e => {
        const key = e.keyCode || e.which;
        if (active && key === 27) {
            Dispatch.emit(Events.SEARCH_CLOSE);
        }
    };

    const cancel = () => {
        if (request) {
            request.abort();
            request = null;
        }
    };

    const clear = () => {
        cancel();
        lastQuery = '';
        heading.text(heading.data('heading'));
        feedback.empty();
        results.get(0).scrollTop = 0;
        results.empty().attr('hidden', '');
    };

    const search = () => {
        request = agent.get(`${dom.data('url')}?q=${field.val().trim()}`);
        request.then(res => {
            const response = $(res.text);
            heading.text('Søkeresultat');
            feedback.html(response.find('[data-feedback-text]').html());
            results.html(response.find('[data-results]').html()).attr('hidden', null);
            results.find('a[data-item]').on('click', e => {
                Dispatch.emit(Events.SEARCH_CLOSE);
            });
        }, error => {
            console.error(error);
        });
    };

    const keyFieldHandler = debounce(() => {
        const query = field.val().trim();
        if (query.length > 2) {
            if (query !== lastQuery) {
                search();
            }
        } else {
            clear();
        }
        lastQuery = query;
    }, 350);

    const onSearchOpen = () => {
        if (!active) {
            active = true;
            trigger = document.activeElement;
            TweenLite.set(el, { display: 'block', opacity: 0 });
            TweenLite.to(el, 0.35, { opacity: 1, ease: Quad.easeInOut });
            Viewport.lockTabbing([el].concat($('[data-search]').nodes));
            document.addEventListener('keyup', keyHandler);
            field.on('keyup', keyFieldHandler).focus();
        }
    };

    const onSearchClose = () => {
        if (active) {
            active = false;
            field.off('keyup', keyFieldHandler);
            document.removeEventListener('keyup', keyHandler);
            TweenLite.to(el, 0.15, { opacity: 0, ease: Quad.easeOut, clearProps: 'all' });
            Viewport.releaseTabbing(trigger);
        }
    };

    const init = () => {
        Dispatch.on(Events.SEARCH_OPEN, onSearchOpen);
        Dispatch.on(Events.SEARCH_CLOSE, onSearchClose);
        body.find(`a[href="${dom.data('url')}"]`).on('click', e => {
            e.preventDefault();
            Dispatch.emit(Events.SEARCH_OPEN);
        });
        close.on('click', () => {
            Dispatch.emit(Events.SEARCH_CLOSE);
        });

        dom.on('submit', e => {
            e.preventDefault();
            search();
        });
        dom.on('reset', e => {
            clear();
            field.focus();
        });
    };

    const destroy = () => {
        Viewport.releaseTabbing();
        dom.off('reset submit');
        close.off('click');
        Dispatch.off(Events.SEARCH_OPEN, onSearchOpen);
        Dispatch.off(Events.SEARCH_CLOSE, onSearchClose);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Search.js